import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgEditIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M8 7H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-7"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="m12.543 14.053-3.245.65.649-3.245 6.489-6.489 2.595 2.596-6.488 6.488ZM19.031 7.565l-2.595-2.596s1.647-2.247 3.244-.65c1.598 1.599-.649 3.246-.649 3.246Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgEditIcon);
const Memo = memo(ForwardRef);
export default Memo;
